<template>
  <transition name="fade">
    <div v-if="show" class="subscription-modal-backdrop">
      <div class="subscription-modal-card">
        <div class="modal-header">
          <h3 class="modal-title">{{ $t('modals.subscription.title') }}</h3>
          <p v-if="paymentFailed" class="text-danger">
            {{ $t('modals.subscription.paymentFailed') }}
          </p>
        </div>

        <div class="plans-container">
          <!-- Premium Plan -->
          <div class="plan-card featured">
            <div class="plan-header">
              <h4>{{ $t('modals.subscription.plans.premium.title') }}</h4>
              <p class="plan-price">{{ $t('modals.subscription.plans.premium.price') }}<span class="price-period">{{ $t('modals.subscription.plans.premium.pricePeriod') }}</span></p>
              <h4>{{ $t('modals.subscription.plans.premium.subtitle') }}</h4>
              <p class="plan-price">{{ $t('modals.subscription.plans.premium.tagline') }}</p>
            </div>
            <div class="plan-features">
              <p>{{ $t('modals.subscription.plans.premium.features.unlimitedQueries') }}</p>
              <p>{{ $t('modals.subscription.plans.premium.features.advancedFeatures') }}</p>
              <p>{{ $t('modals.subscription.plans.premium.features.prioritySupport') }}</p>
              <p>{{ $t('modals.subscription.plans.premium.features.regularUpdates') }}</p>
            </div>
            <button @click="goToContactPage" class="plan-select-btn featured-btn">
              {{ $t('modals.subscription.plans.premium.cta') }}
            </button>
          </div>

          <!-- B2B Plan -->
          <div class="plan-card">
            <div class="plan-header">
              <h4>{{ $t('modals.subscription.plans.business.title') }}</h4>
              <p class="plan-price">{{ $t('modals.subscription.plans.business.price') }}</p>
            </div>
            <div class="plan-features">
              <p>{{ $t('modals.subscription.plans.business.features.unlimitedQueries') }}</p>
              <p>{{ $t('modals.subscription.plans.business.features.customFeatures') }}</p>
              <p>{{ $t('modals.subscription.plans.business.features.dedicatedSupport') }}</p>
              <p>{{ $t('modals.subscription.plans.business.features.trainingOnboarding') }}</p>
            </div>
            <button @click="goToContactPage" class="plan-select-btn outline-btn">
              {{ $t('modals.subscription.plans.business.cta') }}
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <button class="close-button" @click="close">
            {{ $t('common.close') }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SubscriptionModal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    paymentFailed: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },

    selectPlan(priceId) {
      this.$emit('select-plan', priceId);
    },

    goToTrialPage() {
      // Émettre l'événement pour la navigation vers la page d'essai
      this.$emit('navigate-to-trial');
    },

    goToContactPage() {
      // Émettre l'événement pour la navigation vers la page de contact
      // Self-checkout retiré : la conversion passe désormais par un conseiller (sales-led)
      this.$emit('navigate-to-contact');
    }
  }
}
</script>

<style scoped>
.subscription-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.subscription-modal-card {
  background: #fff;
  padding: 32px;
  border-radius: 16px;
  max-width: 900px;
  width: 90%;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
}

.modal-header {
  text-align: center;
  margin-bottom: 30px;
}

.modal-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.text-danger {
  color: #ff5252;
  font-weight: 500;
}

/* Added spacing for the free trial when at top */
.free-trial-container {
  margin-bottom: 30px;
}

.free-trial-card {
  background: #eefbf4;
  border: 1px solid #a3e0c0;
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.trial-info {
  flex: 1;
}

.trial-info h4 {
  font-size: 18px;
  font-weight: 600;
  color: #2a9d58;
  margin-bottom: 8px;
}

.trial-info p {
  font-size: 14px;
  color: #457a5b;
  margin: 0;
}

.trial-btn {
  background: #2a9d58;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
  white-space: nowrap;
  margin-left: 20px;
}

.trial-btn:hover {
  background: #238a4a;
}

.plans-container {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 30px;
}

.plan-card {
  flex: 1;
  background: #f9fafc;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e4e8;
  transition: transform 0.3s, box-shadow 0.3s;
  position: relative;
}

.plan-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.plan-card.featured {
  background: #f2f0ff;
  border: 2px solid #6c63ff;
  transform: scale(1.05);
  z-index: 1;
}

.plan-card.featured:hover {
  transform: scale(1.05) translateY(-5px);
}

.plan-badge {
  position: absolute;
  top: -12px;
  right: 24px;
  background: #6c63ff;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.plan-header {
  margin-bottom: 20px;
  text-align: center;
}

.plan-header h4 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.plan-price {
  font-size: 28px;
  font-weight: 700;
  color: #6c63ff;
}

.price-period {
  font-size: 14px;
  font-weight: 400;
  color: #666;
}

.plan-features {
  flex-grow: 1;
  margin-bottom: 24px;
}

.plan-features p {
  margin-bottom: 12px;
  padding-left: 24px;
  position: relative;
  font-size: 14px;
  color: #555;
}

.plan-features p:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #6c63ff;
  font-weight: bold;
}

.plan-select-btn {
  background: #6c63ff;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
  width: 100%;
}

.plan-select-btn:hover {
  background: #5a54d1;
}

.plan-select-btn.featured-btn {
  background: #6c63ff;
  box-shadow: 0 4px 12px rgba(108, 99, 255, 0.3);
}

.plan-select-btn.outline-btn {
  background: transparent;
  border: 2px solid #6c63ff;
  color: #6c63ff;
}

.plan-select-btn.outline-btn:hover {
  background: rgba(108, 99, 255, 0.1);
}

.modal-footer {
  text-align: center;
  margin-top: 10px;
}

.close-button {
  background: transparent;
  color: #666;
  border: 1px solid #ccc;
  padding: 8px 24px;
  border-radius: 25px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
}

.close-button:hover {
  background: #f0f0f0;
}

/* Fade transition animation - matching existing dashboard animations */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .plans-container {
    flex-direction: column;
  }

  .free-trial-card {
    flex-direction: column;
    text-align: center;
  }

  .trial-btn {
    margin-left: 0;
    margin-top: 16px;
    width: 100%;
  }
}
</style>
